import React from "react";
import { View } from "react-native";
import CustomText from "@components/CustomText";

const IssueTag = ({ title, value }) => {
  return (
    <View
      style={{
        backgroundColor: "rgba(255, 46, 0, 0.10)",
        borderRadius: 20,
        paddingHorizontal: 8,
        paddingVertical: 2,
        marginVertical: 4,
        marginRight: 4,
        flexDirection: "row",
      }}
    >
      <CustomText
        variant="caption_1"
        style={{ color: "rgba(255, 46, 0, 1)", lineHeight: 18 }}
      >
        {`${value} `}
      </CustomText>
      <CustomText
        variant="caption_4"
        style={{ color: "rgba(255, 46, 0, 1)", lineHeight: 18 }}
      >
        {title}
      </CustomText>
    </View>
  );
};

export default IssueTag;
